var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhoto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.2666 21.5844L42.1566 17.8981C41.1729 17.4073 40.4377 16.9144 39.9448 15.9327L38.7168 13.7209C37.9795 12.7372 36.7514 12 35.5232 12H24.9551C23.727 12 22.4989 12.7372 21.7596 13.7209L20.5315 15.9327C20.0407 16.67 19.3034 17.4073 18.3197 17.8981L10.2118 21.5844C8.98369 22.3218 8 23.5498 8 25.0244V45.1749C8 47.1403 9.71895 48.8613 11.6863 48.8613H48.5476C50.513 48.8613 52.2319 47.1403 52.2319 45.1749V25.0244C52.4784 23.3034 51.4947 22.0753 50.2666 21.5844Z",
    stroke: "#000",
    fill: "#fff",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.3613 23.7032C34.9171 23.7032 38.6115 27.3975 38.6115 31.9533C38.6115 36.5092 34.9171 40.2035 30.3613 40.2035C25.8055 40.2035 22.1112 36.5092 22.1112 31.9533C22.1112 27.3975 25.8055 23.7032 30.3613 23.7032Z",
    stroke: "#111111",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoto);
export default __webpack_public_path__ + "static/media/photo.9af2b38d68d93b14bd8ab5c3618e889b.svg";
export { ForwardRef as ReactComponent };